// 引入 DcbRequest 类
import { DcbRequest } from '@dcb/request'
// 引入适配网页的 axios 库
import axios from 'axios'

// 实例化 DcbRequest 类并导出
export const dr = new DcbRequest({
  // axios 实例，必填
  axios: axios,

  // 当前环境，必填，选项：
  // production: 生产环境
  // test: 测试环境
  env: process.env.VUE_APP_RUN_ENV === 'production' ? 'production' : 'test',

  // 应用 ID，对应多多网关的「应用ID」，必填
  appId: process.env.VUE_APP_ID,

  // 应用 RSA 公钥，对应多多网关的「多彩宝RSA公钥」，必填
  appRsaPublicKey: process.env.VUE_APP_RSA_PUBLIC_KEY,

  // 应用 RSA 私钥，对应多多网关的「应用RSA私钥」，必填
  appRsaPrivateKey: process.env.VUE_APP_RSA_PRIVATE_KEY,

  debug: true,

  // API 访问域名，非必填，默认根据当前环境自动设置，非必填
  apiEndpoint: process.env.VUE_APP_API_ENDPOINT,
})
